import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import { Router, Link } from "@reach/router";
import Divider from "@material-ui/core/Divider";
import { withSnackbar } from "notistack";
import SERVER_ADDRESS from "../../../config";
import { testNames, fullGrade, testNameList, simpleFullGrade } from "./config";
import { PieChart, Pie, Legend, Cell } from "recharts";

const useStyles = makeStyles(theme => ({
  chart: {
    margin: "auto"
  }
}));

function getGradeFrequenceData(gradeData) {
  return testNameList.map(testName => {
    //add first test times if not single user
    if (
      testName === "构件辨识实验" &&
      gradeData.filter(grade => grade.test_type === "构件辨识实验").length >= 10
    ) {
      return {
        name: testName,
        value:
          gradeData.filter(grade => grade.test_type === testName).length + 79
      };
    }

    return {
      name: testName,
      value: gradeData.filter(grade => grade.test_type === testName).length
    };
  });
}

const renderCustomizedLabel = ({
  name,
  value,
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index
}) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${value}次`}
    </text>
  );
};

function PieGradeChart(props) {
  const classes = useStyles();

  const { gradeData } = props;
  const data = getGradeFrequenceData(gradeData);
  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#8884d8",
    "#f20cad"
  ];

  return (
    <>
      {gradeData.length > 0 && (
        <PieChart
          width={500}
          height={500}
          innerRadius={200}
          className={classes.chart}
        >
          <Pie
            data={data}
            cx={250}
            cy={250}
            outerRadius={150}
            innerRadius={80}
            fill="#8884d8"
            label={renderCustomizedLabel}
            labelLine={false}
            legendType="circle"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell fill={COLORS[index % COLORS.length]} key={index} />
            ))}
          </Pie>
          {/* <Pie
        data={data02}
        cx={200}
        cy={200}
        innerRadius={200}
        outerRadius={90}
        fill="#82ca9d"
        label
      /> */}
          <Legend />
        </PieChart>
      )}
    </>
  );
}

export default PieGradeChart;
